const MAX_ERROR_LENGTH = 120;

function compactMetadata(metadata) {
  return Object.fromEntries(
    Object.entries(metadata).filter(([, value]) => value !== undefined && value !== ''),
  );
}

function safeText(value) {
  if (value === undefined || value === null) {
    return undefined;
  }
  return String(value).replace(/[\r\n]+/g, ' ').slice(0, MAX_ERROR_LENGTH);
}

function errorName(error) {
  if (!error) {
    return undefined;
  }
  if (typeof error === 'string') {
    return safeText(error);
  }
  return safeText(error.name || error.code || 'Error');
}

function errorDescription(error) {
  if (!error) {
    return undefined;
  }
  return safeText(error.message || error.description || error);
}

export function createLoginStartedPayload({ surface = 'auth', reason = 'user_requested', path = '/' } = {}) {
  return {
    metadata: compactMetadata({
      surface,
      reason,
      path,
    }),
  };
}

export function createLoginFailedPayload({ reason = 'callback_error', error, errorDescription: description, path = '/' } = {}) {
  return {
    metadata: compactMetadata({
      reason,
      error: errorName(error),
      error_description: safeText(description) || errorDescription(error),
      path,
    }),
  };
}

export function createLoginCallbackFunnelEvent({
  error,
  search = typeof window !== 'undefined' ? window.location.search : '',
  path = typeof window !== 'undefined' ? window.location.pathname : '/',
} = {}) {
  const params = new URLSearchParams(search || '');
  const providerError = params.get('error');
  const providerDescription = params.get('error_description');

  if (error || providerError) {
    return {
      eventName: 'login.failed',
      payload: createLoginFailedPayload({
        reason: error ? 'callback_error' : 'provider_error',
        error: providerError || error,
        errorDescription: providerDescription,
        path,
      }),
    };
  }

  return {
    eventName: 'login.completed',
    payload: {
      metadata: compactMetadata({ path }),
    },
  };
}
